import { useEffect, useRef } from 'react'

/**
 * Returns a ref to the shared UC portal target element.
 * Unified components that render floating elements (tooltips, dropdowns)
 * need to portal into a container with the `uc-base` class for styles to apply.
 */
export const useUcPortalTarget = () => {
  const portalTargetRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const portalTarget = document.getElementById('uc-portal-target')
    portalTargetRef.current = portalTarget

    return () => {
      portalTargetRef.current = null
    }
  }, [])

  return { portalTargetRef }
}
